<template>
  <v-layout column>
    <v-flex v-for="(item, index) in data" :key="index">
      <v-layout row wrap pa-2 class="ag-tab-m">
        <v-flex xs9 class="ag-tab-p">
          <v-layout row wrap>
            <v-flex xs6 py-2>
              <span>{{ item.plant_name }}</span>
            </v-flex>
            <v-flex xs6 py-2>
              <span>Gen: {{ item.generation }} KWh</span>
            </v-flex>
            <v-flex xs6 py-2>
              <span>
                <v-icon color="orange" class="ag-place">place</v-icon>
                {{ item.location }}
              </span>
            </v-flex>
            <v-flex xs6 py-2>
              <span>PR: {{item.ratio | round}}%</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3>
          <div>
            <span v-for="(value, key) in item.alert" :key="key">
              <v-tooltip top>
                <v-btn :class="value" class="status-btn" fab small slot="activator"
                  v-on:click="redirectAlert(item.plant_id, alertShorthand[key])">
                  {{alertShorthand[key]}}</v-btn>
              </v-tooltip>
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  mixin
} from '@/util/mixin/index'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  mixins: [mixin],
  data() {
    return {
      alertShorthand: {
        inverter: 'I',
        grid: 'G',
        scb: 'S',
        communication: 'C',
        transformer: 'T',
        zmu: 'Z'
      }
    }
  },
  methods: {
    redirectAlert(plantId, selectedAlert) {
      this.SET_SELECTED_PLANT_ID(+plantId)
      this.$router.push({ 'name': 'alert' })
    }
  }
}
</script>

<style>
.ag-tab-m {
    margin-top: 0px !important;
    padding-left: 5px;
    font-weight: 600;
    font-size: 12px;
    /* color: #2a335a; */
  }
  .ag-tab-p {
    padding: 12px 3px !important;
  }
  .ag-place {
    font-size: 17px !important;
  }
  .status-btn {
    width: 20px !important;
    height: 20px !important;
    /* margin: 6px 3px; */
  }
</style>
